import React from 'react';
import { Link } from '@livecommerce/design-system';
import uniqueId from 'lodash/uniqueId.js';

/**
* @param {txt} string - text to convert to html
* @return {array} - array of html elements
*/

export const textToHtml = (txt = '') => {
  if (!txt) return '';
  const transformNode = node => {
    const { childNodes = [], nodeType, textContent, attributes } = node;
    let { localName } = node;
    if (Node.TEXT_NODE === nodeType) {
      return textContent;
    }
    const children = [...childNodes].map(child => transform(child));
    let props;
    switch (localName) {
      case 'a':
        localName = Link;
        props = {
          href: attributes.getNamedItem('href')?.value,
          target: attributes.getNamedItem('target')?.value,
        };
        break;
      default:
        props = null;
    }
    return React.createElement(localName, { key: `html-${uniqueId()}`, ...props }, children[0]);
  };

  const transform = node => {
    const result = [];
    do {
      result.push(transformNode(node));
      node = node.nextSibling;
    } while (node !== null);
    return result;
  };

  const node = new DOMParser().parseFromString(txt, 'text/html').body.firstChild;
  return transform(node).map(element => element);
};
